import {
    Button,
    Divider,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Typography,
    Autocomplete,
    TextField
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import TreeSelect from "../../../components/TreeSelect";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

const ENTITY_TYPES = ["CATEGORY", "PRODUCT", "SKU"];

export default function DiscountSearchContainer({
    filters,
    stores,
    onChange,
    onSearch,
    onClear,
    onCreateDiscount,
    entityOptions,
    canManageDiscounts,
}) {
    const selectedEntityIds = Array.isArray(filters.entityId)
        ? filters.entityId.map(String)
        : filters.entityId
            ? [String(filters.entityId)]
            : [];

    const handleClearEntityType = (e) => {
        e.stopPropagation();
        onChange("entityType", "");
        onChange("entityId", []);
    };

    return (
        <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Liquidation Sale Discount
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Grid container spacing={2} alignItems="flex-start">
                <Grid item size={{ xs: 12, md: 4 }}>
                    <Autocomplete
                        fullWidth
                        size="small"
                        options={stores}
                        value={stores.find((s) => String(s.storeId) === String(filters.storeId)) || null}
                        isOptionEqualToValue={(option, selected) =>
                            String(option.storeId) === String(selected.storeId)
                        }
                        getOptionLabel={(option) => `${option?.storeId} - ${option?.storeName || ""}`}
                        onChange={(_, selectedStore) => onChange("storeId", selectedStore?.storeId ?? "")}
                        renderInput={(params) => <TextField {...params} label="Store" />}
                    />
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="discount-search-entity-type-label">Entity Type</InputLabel>
                        <Select
                            labelId="discount-search-entity-type-label"
                            value={filters.entityType}
                            label="Entity Type"
                            onChange={(event) => onChange("entityType", event.target.value)}
                            endAdornment={
                                filters.entityType && (
                                    <IconButton size="small" onClick={handleClearEntityType} sx={{ mr: 1 }}>
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                )
                            }
                        >
                            {ENTITY_TYPES.map((type) => (
                                <MenuItem key={type} value={type}>
                                    {type}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth size="small" disabled={!filters.entityType}>
                        {filters.entityType === "CATEGORY" ? (
                            <TreeSelect
                                labelId="discount-search-entity-id-label"
                                label="Entity ID"
                                multiple
                                value={selectedEntityIds}
                                options={entityOptions}
                                onChange={(event) => onChange("entityId", event.target.value)}
                            />
                        ) : (
                            <Autocomplete
                                multiple
                                size="small"
                                options={entityOptions}
                                value={entityOptions.filter((option) => selectedEntityIds.includes(String(option.id)))}
                                isOptionEqualToValue={(option, selected) =>
                                    String(option.id) === String(selected.id)
                                }
                                getOptionLabel={(option) => `#${option.id} - ${option.name}`}
                                onChange={(_, selectedOptions) => {
                                    onChange(
                                        "entityId",
                                        selectedOptions.map((option) => String(option.id))
                                    );
                                }}
                                renderInput={(params) => <TextField {...params} label="Entity ID" />}
                            />
                        )}
                    </FormControl>
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <Button variant="outlined" onClick={onSearch} sx={{ mr: 1 }} startIcon={<SearchIcon />}>
                        Search
                    </Button>

                    <Button variant="outlined" onClick={onClear} sx={{ mr: 1 }} color="error">
                        Clear All
                    </Button>

                    {canManageDiscounts && (
                        <Button variant="contained" color="primary" onClick={onCreateDiscount} startIcon={<AddIcon />}>
                            Create Discount
                        </Button>
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
}